export const ROOT_ROLE = "ROOT";
export const ADMIN_ROLE = "ADMIN";
